import _cloneDeep from 'lodash.clonedeep'
import _isEqual from 'lodash.isequal'

import {
  hasTransportationRole as hasTransportationRoleFunc,
  isAuthorized,
  addAlert,
  ROOT_EMAIL
} from '../../../../utilities/helpers'

import {
  deleteTransportationOwnerUser,
  deleteTransportationOwnerUserInvite,
  resendTransportationOwnerUserInvite,
  createTransportationOwnerUser,
  updateTransportationOwnerUser,
  getTransportationOwnerUser,
  archiveTransportationUserMoneyAccount,
  createTransportationUserMoneyAccount, updateTransportationUserMoneyAccount
} from '../../../../services/transportation-owner-users-service'

import {
  updateTransportationUserIdentifier,
  createTransportationUserIdentifier,
  deRegisterTransportationUserMomoAccount
} from '../../../../services/transportation-user-identifiers-service'

import { formatDate, formatTime } from '@smarttransit/common/src/helpers'
import { getCachedMoneyAccountTypes } from '@/services/st-settings-service'

export default {
  name: 'transportation-user',
  props: {
    signedInUser: Object,
    transportationOwnerUserId: String
  },
  data () {
    return {
      apiInProgress: false,
      transportationOwnerUser: null,
      phonePrefix: null,
      moneyAccountTypes: [],
      unfilteredMoneyAccountTypes: [],
      transportationRoles: [],
      userTypesByAuthorization: [],
      moneyAccountModal: false,
      selectedMoneyAccount: null,
      isMoneyAccountLoading: false,
      selectedExistingUser: null,
      sendInvitation: true
    }
  },
  computed: {
    selectedMoneyAccountCategory () {
      return this.getMoneyAccountCategory(this.selectedMoneyAccount?.moneyAccountTypeId)
    }
  },
  mounted: function () {
    this.moneyAccountTypes = this.$store.getters.getMoneyAccountTypes
    this.moneyAccountLogos = this.$store.getters.getMoneyAccountLogos
    this.transportationRoles = this.$store.getters.getTransportationRoles

    getCachedMoneyAccountTypes().then((result) => {
      this.unfilteredMoneyAccountTypes = result || []
    })

    if (this.$props.signedInUser) {
      let filteredUserTypes = [{ text: 'Not authorized to set a user type', value: 'none' }]

      if (this.$props.signedInUser) {
        if (this.hasUserType('admin') || this.hasTransportationRole('OWNER')) {
          filteredUserTypes = this.transportationRoles.filter(o => o.value !== 'OWNER')
        } else if (this.hasTransportationRole('ADMIN')) {
          filteredUserTypes = this.transportationRoles.filter(o => o.value === 'DRIVER')
        }
      }

      this.userTypesByAuthorization = filteredUserTypes
    } else {
      this.userTypesByAuthorization = []
    }

    this.$nextTick(() => {
      if (this.$route.params.transportationOwnerUserId === '0') {
        this.transportationOwnerUser = {
          userType: this.userTypesByAuthorization && this.userTypesByAuthorization.length === 1 ? this.userTypesByAuthorization[0].value : 'DRIVER',
          verificationType: 'phone'
        }

        this.clonedTransportationOwnerUser = _cloneDeep(this.transportationOwnerUser)
      } else {
        this.loadUser(this.$route.params.transportationOwnerUserId)
      }
    })
  },
  methods: {
    getMoneyAccountCategory (moneyAccountTypeId) {
      return this.unfilteredMoneyAccountTypes.find(o => o.typeId === moneyAccountTypeId)?.typeCategory
    },
    loadMoneyAccountModal (data) {
      // this will accommodate both mobile money and money account
      this.selectedMoneyAccount = {
        externalId: '',
        accountMetadata: {},
        transportationUserIdentifier: {},
        ...data
      }

      this.moneyAccountModal = true
    },
    async deregisterMomoAccount (id, phoneNumber) {
      if (confirm(`Confirm removing this mobile money account: ${phoneNumber}`)) {
        try {
          const result = await deRegisterTransportationUserMomoAccount({ id })

          if (result?.success) {
            addAlert({ message: 'Successfully removed mobile money account', type: 'success' })
          }

          this.transportationOwnerUser.transportationUserIdentifiers.forEach((transportationUserIdentifier, index) => {
            this.transportationOwnerUser.transportationUserIdentifiers[index].transportationUserMomoAccounts = transportationUserIdentifier.transportationUserMomoAccounts.filter(o => o.id !== id)
          })

          this.transportationOwnerUser.transportationMobileMoneyAccounts = this.getTransportationMobileMoneyAccounts(this.transportationOwnerUser.transportationUserIdentifiers)
          this.clonedTransportationOwnerUser.transportationMobileMoneyAccounts = _cloneDeep(this.transportationOwnerUser.transportationMobileMoneyAccounts)
          this.clonedTransportationOwnerUser.transportationUserIdentifiers = _cloneDeep(this.transportationOwnerUser.transportationUserIdentifiers)
          return result?.success
        } catch (err) {
          addAlert({ message: err, type: 'error' })
        }
      }
    },
    async archiveMoneyAccount (id, externalId) {
      if (confirm(`Confirm removing this account: ${externalId}`)) {
        try {
          const result = await archiveTransportationUserMoneyAccount(id)

          if (result?.success) {
            addAlert({ message: 'Successfully removed money account', type: 'success' })
          }

          this.transportationOwnerUser.transportationUserMoneyAccounts = this.transportationOwnerUser.transportationUserMoneyAccounts.filter(o => o.id !== id)
          this.clonedTransportationOwnerUser.transportationUserMoneyAccounts = _cloneDeep(this.transportationOwnerUser.transportationUserMoneyAccounts)
          return result?.success
        } catch (err) {
          addAlert({ message: err, type: 'error' })
        }
      }
    },
    async archiveSelectedMoneyAccount () {
      let result = false

      if (this.selectedMoneyAccountCategory === 'bank') {
        result = await this.archiveMoneyAccount(this.selectedMoneyAccount.id, this.selectedMoneyAccount.externalId)
      } else {
        result = await this.deregisterMomoAccount(this.selectedMoneyAccount.id, this.selectedMoneyAccount.transportationUserIdentifier.phoneNumber)
      }

      if (result) {
        this.moneyAccountModal = false
      }
    },
    async saveMoneyAccount () {
      if (this.selectedMoneyAccountCategory === 'mobile_money') {
        return this.saveMobileMoneyUser()
      } else {
        try {
          let result = null

          if (this.selectedMoneyAccountCategory === 'bank') {
            if (!this.selectedMoneyAccount.externalId ||
                !this.selectedMoneyAccount.accountMetadata.bankName ||
                !this.selectedMoneyAccount.accountMetadata.accountFullname) {
              return alert('Please enter account number, bank name and account holder\'s full name')
            }
          }

          if (this.selectedMoneyAccount.id) {
            this.isMoneyAccountLoading = true

            result = await updateTransportationUserMoneyAccount({
              id: this.selectedMoneyAccount.id,
              transportationOwnerUserId: this.transportationOwnerUser.id,
              moneyAccountTypeId: this.selectedMoneyAccount.moneyAccountTypeId,
              externalId: this.selectedMoneyAccount.externalId,
              accountMetadata: this.selectedMoneyAccount.accountMetadata
            })
          } else {
            result = await createTransportationUserMoneyAccount({
              transportationOwnerUserId: this.transportationOwnerUser.id,
              moneyAccountTypeId: this.selectedMoneyAccount.moneyAccountTypeId,
              externalId: this.selectedMoneyAccount.externalId,
              accountMetadata: this.selectedMoneyAccount.accountMetadata
            })
          }

          const transportationUserMoneyAccountIndex = (this.transportationOwnerUser.transportationUserMoneyAccounts || []).findIndex((o) => o.id === result.id)

          if (transportationUserMoneyAccountIndex > -1) {
            this.transportationOwnerUser.transportationUserMoneyAccounts[transportationUserMoneyAccountIndex] = result
          } else {
            this.transportationOwnerUser.transportationUserMoneyAccounts.push(result)
          }

          this.clonedTransportationOwnerUser.transportationUserMoneyAccounts = _cloneDeep(this.transportationOwnerUser.transportationUserMoneyAccounts)
          this.moneyAccountModal = false
          addAlert({ message: `Successfully updated money account ${this.selectedMoneyAccount.externalId}`, type: 'success' })
        } catch (err) {
          addAlert({ message: err, type: 'error' })
        } finally {
          this.isMoneyAccountLoading = false
        }
      }
    },
    hasUserType (role) {
      const { signedInUser } = this.$props
      return (signedInUser && isAuthorized(signedInUser, role))
    },
    setPhonePrefixByCountryId (countryId) {
      switch (countryId) {
        case 'GHA':
          this.phonePrefix = '+233'
          break
      }
    },
    hasTransportationRole (transportationRole) {
      const { signedInUser } = this.$props

      if (signedInUser && this.transportationOwnerUser) {
        return hasTransportationRoleFunc(signedInUser, transportationRole, this.transportationOwnerUser.transportationOwnerId, this.transportationOwnerUser)
      }
    },
    isEdited () {
      return !_isEqual(this.transportationOwnerUser, this.clonedTransportationOwnerUser)
    },
    getTransportationMobileMoneyAccounts (transportationUserIdentifiers) {
      return transportationUserIdentifiers.filter((o) => o.transportationUserMomoAccounts.length)
        .reduce((acc, currVal) => {
          const { transportationUserMomoAccounts, ...rest } = currVal
          acc = acc.concat(currVal.transportationUserMomoAccounts.map((o) => ({ ...o, transportationUserIdentifier: { ...rest } })))
          return acc
        }, [])
    },
    async loadUser (transportationOwnerUserId) {
      try {
        this.apiInProgress = true

        const transportationOwnerUser = await getTransportationOwnerUser({
          id: transportationOwnerUserId,
          filter: { include: ['stUser', 'transportationOwner', 'transportationUserMoneyAccounts', { transportationUserIdentifiers: 'transportationUserMomoAccounts' }] }
        })

        this.transportationOwnerUser = {
          ...transportationOwnerUser,
          firstName: transportationOwnerUser.stUser.firstName,
          lastName: transportationOwnerUser.stUser.lastName,
          email: transportationOwnerUser.stUser.email,
          phone: transportationOwnerUser.stUser.phone,
          transportationMobileMoneyAccounts: this.getTransportationMobileMoneyAccounts(transportationOwnerUser.transportationUserIdentifiers),
          verificationTokenExpiryLabel: transportationOwnerUser.verificationTokenExpiry ? `${formatTime(transportationOwnerUser.verificationTokenExpiry)}, ${formatDate(transportationOwnerUser.verificationTokenExpiry)}` : '',
          isExpired: transportationOwnerUser.verificationTokenExpiry && new Date(transportationOwnerUser.verificationTokenExpiry) < new Date(),
          isEditable: this.isUserEditable(transportationOwnerUser),
          userType: this.getUserTypeLabel(transportationOwnerUser.roles, 'returnValue'),
          excludeFeeLabel: !!(transportationOwnerUser.details && transportationOwnerUser.details.excludeFeeLabel)
        }

        this.setPhonePrefixByCountryId(this.transportationOwnerUser.transportationOwner.currentCountryId)
        this.clonedTransportationOwnerUser = _cloneDeep(this.transportationOwnerUser)
      } catch (err) {
        addAlert({ message: err, type: 'error' })
      } finally {
        this.apiInProgress = false
      }
    },
    cancelEdit () {
      if (this.isEdited()) {
        if (confirm('Are you sure you want to cancel editing?')) {
          this.$router.push({ name: 'transportation-accounts-users' })
        }
      } else {
        this.$router.push({ name: 'transportation-accounts-users' })
      }
    },
    async saveMobileMoneyUser () {
      if (!this.selectedMoneyAccount.transportationUserIdentifier?.phoneNumber || !this.selectedMoneyAccount.moneyAccountTypeId) {
        return addAlert({ message: 'Please enter mobile money number and money account type', type: 'error' })
      }

      try {
        this.isMoneyAccountLoading = true
        let result = null
        const transportationUserIdentifiersFound = this.transportationOwnerUser.transportationUserIdentifiers.find((o) => o.phoneNumber === this.selectedMoneyAccount.transportationUserIdentifier.phoneNumber)

        if (transportationUserIdentifiersFound) {
          result = await updateTransportationUserIdentifier({
            id: transportationUserIdentifiersFound.id,
            phoneNumber: this.selectedMoneyAccount.transportationUserIdentifier.phoneNumber,
            moneyAccountTypeId: this.selectedMoneyAccount.moneyAccountTypeId
          })
        } else {
          result = await createTransportationUserIdentifier({
            phoneNumber: this.selectedMoneyAccount.transportationUserIdentifier.phoneNumber,
            transportationOwnerUserId: this.transportationOwnerUser.id,
            moneyAccountTypeId: this.selectedMoneyAccount.moneyAccountTypeId
          })
        }

        addAlert({ message: `Successfully updated mobile money account ${this.selectedMoneyAccount.transportationUserIdentifier.phoneNumber}`, type: 'success' })
        const transportationUserIdentifierIndex = (this.transportationOwnerUser.transportationUserIdentifiers || []).findIndex((o) => o.id === result.id)

        if (transportationUserIdentifierIndex > -1) {
          this.transportationOwnerUser.transportationUserIdentifiers[transportationUserIdentifierIndex] = result
        } else {
          this.transportationOwnerUser.transportationUserIdentifiers.push(result)
        }

        this.transportationOwnerUser.transportationMobileMoneyAccounts = this.getTransportationMobileMoneyAccounts(this.transportationOwnerUser.transportationUserIdentifiers)

        this.clonedTransportationOwnerUser.transportationMobileMoneyAccounts = _cloneDeep(this.transportationOwnerUser.transportationMobileMoneyAccounts)
        this.clonedTransportationOwnerUser.transportationUserIdentifiers = _cloneDeep(this.transportationOwnerUser.transportationUserIdentifiers)
        this.moneyAccountModal = false
      } catch (err) {
        addAlert({ message: err, type: 'error' })
      } finally {
        this.isMoneyAccountLoading = false
      }
    },
    saveUser () {
      if (!this.transportationOwnerUser?.id) {
        return this.inviteUser()
      } else {
        return this.updateUser()
      }
    },
    async updateUser () {
      try {
        if (this.transportationOwnerUser.isEditable) {
          this.apiInProgress = true

          await updateTransportationOwnerUser({
            id: this.transportationOwnerUser.id,
            firstName: this.transportationOwnerUser.firstName,
            lastName: this.transportationOwnerUser.lastName,
            email: this.transportationOwnerUser.email,
            phone: !this.transportationOwnerUser.phone || this.transportationOwnerUser.phone === 'null' || this.transportationOwnerUser.phone === this.phonePrefix ? undefined : this.transportationOwnerUser.phone,
            role: this.transportationOwnerUser.userType,
            excludeFeeLabel: this.transportationOwnerUser.excludeFeeLabel
          })

          this.loadUser(this.transportationOwnerUser.id)

          addAlert({
            message: `Successfully updated user ${this.transportationOwnerUser.firstName} ${this.transportationOwnerUser.lastName}`,
            type: 'success'
          })
        }
      } catch (err) {
        addAlert({ message: err, type: 'error' })
      } finally {
        this.apiInProgress = false
      }
    },
    async inviteUser () {
      if (!this.$route.params.accountId) {
        return alert('Please select an account')
      }
      if (!this.transportationOwnerUser || (!this.transportationOwnerUser.email && !this.transportationOwnerUser.phone) || !this.transportationOwnerUser.firstName || !this.transportationOwnerUser.lastName || !this.transportationOwnerUser.userType) {
        return alert('One of email, phone, first name, last name or user type not provided')
      }
      if (!this.transportationOwnerUser.userType) {
        return alert('Please select a user type')
      }

      try {
        await createTransportationOwnerUser({
          transportationOwnerId: this.$route.params.accountId,
          email: this.transportationOwnerUser.verificationType === 'email' ? this.transportationOwnerUser.email : '',
          phone: this.transportationOwnerUser.verificationType === 'phone' ? this.transportationOwnerUser.phone : '',
          firstName: this.selectedExistingUser?.id ? null : this.transportationOwnerUser.firstName,
          lastName: this.selectedExistingUser?.id ? null : this.transportationOwnerUser.lastName,
          roles: [this.transportationOwnerUser.userType],
          stUserId: this.selectedExistingUser?.id,
          verificationType: this.transportationOwnerUser.verificationType,
          noVerificationNotice: !this.sendInvitation
        })

        addAlert({ message: `Successfully ${this.transportationOwnerUser.noVerificationNotice ? 'created user' : 'sent invitation for'} ${this.transportationOwnerUser.firstName} ${this.transportationOwnerUser.lastName}`, type: 'success' })
        this.$router.push({ name: 'transportation-accounts-users' })
      } catch (err) {
        addAlert({ message: err, type: 'error' })
      } finally {
        this.apiInProgress = false
      }
    },
    async resendUserInvitation () {
      if (confirm(`Confirm re-sending invitation for ${this.transportationOwnerUser.stUser.firstName || ''} ${this.transportationOwnerUser.stUser.lastName}`)) {
        const { accountId } = this.$props.params

        try {
          this.apiInProgress = true
          await resendTransportationOwnerUserInvite({ transportationOwnerUserId: this.transportationOwnerUser.id, transportationOwnerId: accountId })
          addAlert({ message: `Successfully re-sent invitation for ${this.transportationOwnerUser.stUser.firstName || ''} ${this.transportationOwnerUser.stUser.lastName}`, type: 'success' })
        } catch (err) {
          addAlert({ message: `Error in re-sending invite for user: ${JSON.stringify(err)}`, type: 'error' })
        } finally {
          this.apiInProgress = false
        }
      }
    },
    async cancelInvitedUser () {
      if (confirm(`Confirm cancelling invitation for ${this.transportationOwnerUser.stUser.firstName || ''} ${this.transportationOwnerUser.stUser.lastName}`)) {
        await deleteTransportationOwnerUserInvite({ transportationOwnerUserId: this.transportationOwnerUser.id })
        addAlert({ message: `Successfully deleted invitation for ${this.transportationOwnerUser.stUser.firstName || ''} ${this.transportationOwnerUser.stUser.lastName}`, type: 'success' })
        this.$router.push({ name: 'transportation-accounts-users' })
      }
    },
    deleteUser (user) {
      if (user.isOwner || !user.isEditable) {
        return alert('Account owner cannot be deleted, please archive the account')
      }

      if (this.hasUserType('admin') || this.hasTransportationRole('OWNER')) {
        if (confirm(`Confirm permanently deleting "${user.stUser.firstName || ''} ${user.stUser.lastName}" from this account?`)) {
          this.apiInProgress = true

          deleteTransportationOwnerUser({
            id: user.id
          }).then(() => {
            addAlert({ message: `Successfully removed user ${user.stUser.firstName || ''} ${user.stUser.lastName} from account`, type: 'success' })
          }).catch((err) => {
            addAlert({ message: err, type: 'error' })
          }).finally(() => {
            this.apiInProgress = false
          })
        }
      }
    },
    getUserTypeLabel (roles, returnValue) {
      if (roles.indexOf('OWNER') > -1) {
        return returnValue ? 'OWNER' : 'Owner'
      }

      if (roles.indexOf('ADMIN') > -1) {
        return returnValue ? 'ADMIN' : 'Admin'
      }

      if (roles.indexOf('DRIVER') > -1) {
        return returnValue ? 'DRIVER' : 'User'
      }
    },
    isUserEditable (user, ignoreIfEmailSame) {
      let isEditable = false
      user = user || this.transportationOwnerUser

      if ((!ignoreIfEmailSame && this.$props.signedInUser.email === user?.email) || this.$props.signedInUser?.email === ROOT_EMAIL) {
        isEditable = true
      } else if (this.hasUserType('admin')) {
        isEditable = true
      } else if (user?.roles?.indexOf('OWNER') > -1 || user?.roles?.indexOf('ADMIN') > -1) {
        isEditable = this.hasUserType('admin') || this.hasTransportationRole('OWNER')
      } else {
        isEditable = this.hasTransportationRole('ADMIN')
      }

      return isEditable
    }
  },
  beforeDestroy () {
  }
}
